// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ObjectNoResponse,
    ProviderUpdateUserPayload,
    ProviderUser,
    ProviderUserSortType,
    RetoolEnvironmentType,
    TemporaryResponseToken,
    TemporaryUrl,
    ProviderUpdateUserPayloadToJSON,
    ObjectNoResponseFromJSON,
    ProviderUserFromJSON,
    TemporaryResponseTokenFromJSON,
    TemporaryUrlFromJSON,
} from '../models';

export interface DisableProviderUserRequest {
    id: string;
}

export interface ListProviderUsersRequest {
    filterActive?: string;
    order?: Array<ListProviderUsersOrderEnum>;
    sort?: Array<ProviderUserSortType>;
}

export interface PostSupportRetoolEmbedUrlRequest {
    id: string;
    environment?: RetoolEnvironmentType;
}

export interface UpdateProviderUserRequest {
    id: string;
    providerUpdateUserPayload: ProviderUpdateUserPayload;
}

/**
 * no description
 */
export class UserApi extends runtime.BaseAPI {

    /**
     * Update a user\'s permissions
     * Update a user\'s permissions
     */
    async disableProviderUserRaw(requestParameters: DisableProviderUserRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableProviderUser.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["delete:grant"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/user/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Update a user\'s permissions
     * Update a user\'s permissions
     */
    async disableProviderUser(requestParameters: DisableProviderUserRequest): Promise<ObjectNoResponse> {
        const response = await this.disableProviderUserRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a list of users
     * Get a list of users
     */
    async listProviderUsersRaw(requestParameters: ListProviderUsersRequest): Promise<runtime.ApiResponse<Array<ProviderUser>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:user"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/user`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderUserFromJSON));
    }

    /**
     * Get a list of users
     * Get a list of users
     */
    async listProviderUsers(requestParameters: ListProviderUsersRequest): Promise<Array<ProviderUser>> {
        const response = await this.listProviderUsersRaw(requestParameters);
        return await response.value();
    }

    /**
     * Generate a retool embed url
     * Generate a a retool embed url
     */
    async postSupportRetoolEmbedUrlRaw(requestParameters: PostSupportRetoolEmbedUrlRequest): Promise<runtime.ApiResponse<TemporaryUrl>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportRetoolEmbedUrl.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.environment !== undefined) {
            queryParameters['environment'] = requestParameters.environment;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/user/retool/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TemporaryUrlFromJSON(jsonValue));
    }

    /**
     * Generate a retool embed url
     * Generate a a retool embed url
     */
    async postSupportRetoolEmbedUrl(requestParameters: PostSupportRetoolEmbedUrlRequest): Promise<TemporaryUrl> {
        const response = await this.postSupportRetoolEmbedUrlRaw(requestParameters);
        return await response.value();
    }

    /**
     * Generate a temporary session token
     * Generate a temporary session token
     */
    async postSupportTemporarySessionTokenRaw(): Promise<runtime.ApiResponse<TemporaryResponseToken>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/user/temporary_token`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TemporaryResponseTokenFromJSON(jsonValue));
    }

    /**
     * Generate a temporary session token
     * Generate a temporary session token
     */
    async postSupportTemporarySessionToken(): Promise<TemporaryResponseToken> {
        const response = await this.postSupportTemporarySessionTokenRaw();
        return await response.value();
    }

    /**
     * Update a user\'s permissions
     * Update a user\'s permissions
     */
    async updateProviderUserRaw(requestParameters: UpdateProviderUserRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateProviderUser.');
        }

        if (requestParameters['providerUpdateUserPayload'] === null || requestParameters['providerUpdateUserPayload'] === undefined) {
            throw new runtime.RequiredError('providerUpdateUserPayload','Required parameter requestParameters.providerUpdateUserPayload was null or undefined when calling updateProviderUser.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:grant"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/user/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderUpdateUserPayloadToJSON(requestParameters['providerUpdateUserPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Update a user\'s permissions
     * Update a user\'s permissions
     */
    async updateProviderUser(requestParameters: UpdateProviderUserRequest): Promise<ObjectNoResponse> {
        const response = await this.updateProviderUserRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListProviderUsersOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
